// extracted by mini-css-extract-plugin
module.exports = {"auBanner":"auBanner_auBanner__n_c52"};